<div class="container-fluid" >
    <div class="mt-5 mb-5"><h1>Dashboard / Report</h1></div>

    <div class="search-type-section mt-3 mb-3">
        <div class="row row-cols-lg-auto g-3 align-items-center">
            <div class="col-12">
                <label class="" for="inlineFormSelectPref">Select By</label>
                <select class="form-select" id="inlineFormSelectPref" [(ngModel)]="searchObj.searchBy" (change)="searchByChange()">
                    <option value="">Select Option</option>
                    <option value="byDate">Date</option>
                    <option value="byEmail">Email ID</option>
                    <option value="byRequest">Request Type</option>
                </select>
            </div>
            <div class="col-12" *ngIf="searchObj.searchBy && searchObj.searchBy == 'byEmail' ">
              <label class="" for="emailId">Email ID</label>
              <div class="input-group">
                <input type="email" class="form-control" id="emailId" [(ngModel)]="searchObj.searchByEmail" placeholder="Enter your email ID">
              </div>
            </div>

            <div class="col-12" *ngIf="searchObj.searchBy && searchObj.searchBy == 'byRequest' ">
                <label class="" for="requestType">Request Type</label>
                <div class="input-group">
                  <input type="text" class="form-control" id="requestType" [(ngModel)]="searchObj.searchByRequest" placeholder="Enter data">
                </div>
            </div>
          
          
            <!-- <div class="col-12">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="inlineFormCheck">
                <label class="form-check-label" for="inlineFormCheck">
                  Remember me
                </label>
              </div>
            </div> -->
          
            <div class="col-12 pt-4">
              <button type="submit" class="btn btn-warning">Submit</button>
            </div>
            <div class="col-12 pt-4">
                <button type="submit" class="btn btn-outline-dark" (click)="clearSearch()">Clear</button>
            </div>
        </div>
    </div>
    <div>
        <form class="row row-cols-sm-auto">
            <div class="col-12">
                <div class="input-group">
                    <input
                        class="form-control"
                        placeholder="yyyy-mm-dd"
                        name="dp"
                        [(ngModel)]="model"
                        ngbDatepicker
                        #d="ngbDatepicker"
                    />
                    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()" type="button"></button>
                </div>
            </div>
        </form>
    </div>

    <div class="row">
        <div class="col-12">
            <table class="table table-bordered mt-4" style="word-break: break-word;">
                <thead class="table-light">
                      <tr>
                          <th style="text-align:center; background-color:#F1F1F1;">Date</th>
                          <th style="text-align:center; background-color:#F1F1F1;">Time</th>
                          <th style="text-align:center; background-color:#F1F1F1;">Email ID</th>
                          <th style="text-align:center; background-color:#F1F1F1;">Specification</th>
                          <th style="text-align:center; background-color:#F1F1F1;">Rquest Type</th>
                          <th style="text-align:center; background-color:#F1F1F1;">Request Placed</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr >
                          <td style="vertical-align: top;"> </td>
                          <td style="vertical-align: top;"> </td>
                          <td style="vertical-align: top;"> </td>
                          <td style="vertical-align: top;"> </td>
                          <td style="vertical-align: top;"> </td>
                          <td style="vertical-align: top;"> </td>
                      </tr>
                      <tr >
                          <td style="vertical-align: top;"> </td>
                          <td style="vertical-align: top;"> </td>
                          <td style="vertical-align: top;"> </td>
                          <td style="vertical-align: top;"> </td>
                          <td style="vertical-align: top;"> </td>
                          <td style="vertical-align: top;"> </td>
                      </tr>
                  </tbody>
              </table>
        </div>
    </div>
</div>




